(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/sort-games.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/sort-games.js');
"use strict";

const {
  DropdownSelectItem,
  DropdownItem,
  DropdownLabel
} = svs.ui.ReactDropdown;
const {
  ReactIcon: Icon
} = svs.ui;
const SortGames = _ref => {
  var _activeOption$label;
  let {
    selected,
    setSelected,
    hideDefault = false,
    placeholderLabel = 'Sortera'
  } = _ref;
  const {
    sortOptions,
    getSortOptionById
  } = svs.eInstant.constants;
  const filteredOptions = React.useMemo(() => hideDefault ? sortOptions.filter(opt => opt.id !== 'default') : sortOptions, [hideDefault, sortOptions]);
  const current = getSortOptionById(selected);
  const activeOption = hideDefault && (current === null || current === void 0 ? void 0 : current.id) === 'default' ? null : current;
  const buttonLabel = (_activeOption$label = activeOption === null || activeOption === void 0 ? void 0 : activeOption.label) !== null && _activeOption$label !== void 0 ? _activeOption$label : placeholderLabel;
  return React.createElement(DropdownSelectItem, {
    defaultText: buttonLabel,
    onSelect: setSelected,
    v2: true
  }, filteredOptions.map(option => React.createElement(DropdownItem, {
    "aria-selected": (activeOption === null || activeOption === void 0 ? void 0 : activeOption.id) === option.id,
    key: option.id,
    name: option.id,
    selected: (activeOption === null || activeOption === void 0 ? void 0 : activeOption.id) === option.id
  }, React.createElement(Icon, {
    className: option.iconClasses,
    icon: option.icon
  }), React.createElement(DropdownLabel, null, option.label))));
};
setGlobal('svs.eInstant.shared.components.SortGames', SortGames);

 })(window);